import React, {useCallback} from "react";
import {PureButton} from "components/Common";
import {IconCopy} from "components/Icons";
import useClipboard from "react-use-clipboard";
import {getLinkFromSharePublicMethod} from "modules/utils/share";
import {ShareTarget} from "modules/enums";
import {useGenerateShareMessage} from "modules/utils/hooks";
import {useSelector} from "react-redux";
import {getActiveContest, getUserStore} from "modules/selectors";

interface IProps {
	clickCallback?: () => void;
}

export const CopyHandler: React.FC<IProps> = ({clickCallback}) => {
	const contest = useSelector(getActiveContest);
	const userId = useSelector(getUserStore).currentUser?.id;
	const message = useGenerateShareMessage();

	const link = getLinkFromSharePublicMethod({
		target: ShareTarget.Native,
		contestId: contest?.id ?? 0,
		userId: userId ?? 0,
		message,
	});
	const [isCopied, setCopied] = useClipboard(`${message}${link}`, {
		successDuration: 1000,
	});

	const color = isCopied ? "#000000" : "#222222";

	const handleCopy = useCallback(() => {
		setCopied();
		if (clickCallback) {
			clickCallback();
		}
	}, [clickCallback, setCopied]);

	if (!userId || !contest) {
		return null;
	}

	return (
		<PureButton onClick={handleCopy}>
			<IconCopy color={color} width={24} />
		</PureButton>
	);
};
